import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilegrantIconLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Livello_2",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 57 58",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .st0 {\n        fill: #ff0060;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M52.8,20.5c-1-2.2-2.6-3.7-6.5-7.2l-7.6-6.5c-3.3-3-4.8-4.3-6.7-5-1.8-.7-5.6-.8-9.4-.8h-.1c-1.8,0-4.9,0-7.9.4-3.3.4-5.5,1.4-7.2,3-1.7,1.7-2.6,3.8-3,7.1-.4,3-.4,6.8-.4,12v10.8c0,5.2,0,9,.4,12,.4,3.3,1.4,5.5,3,7.1s3.8,2.6,7.1,3c2.6.3,5.6.4,7.9.4h0s8.8,0,8.8,0c5.2,0,9,0,12-.4,3.3-.4,5.5-1.4,7.1-3,1.7-1.7,2.6-3.8,3-7.1.4-3,.4-6.8.4-12v-4.3c0-5.2,0-7.4-1-9.6ZM44.9,14.8c2.4,2.1,3.8,3.5,4.8,4.6h-6.3c-5.2,0-7.8,0-9.2-1.4-1.4-1.4-1.4-4-1.4-9.2v-4.4c1.1.7,2.4,1.9,4.6,3.9l7.6,6.5ZM51.7,34.4c0,5.1,0,8.9-.4,11.7-.4,2.8-1.1,4.6-2.5,6-1.3,1.3-3.1,2.1-6,2.5-2.9.4-6.6.4-11.7.4h-7.8c-2.3,0-5.7,0-8.5-.4-2.8-.4-4.6-1.1-6-2.5s-2.1-3.1-2.5-6c-.4-2.9-.4-6.6-.4-11.7v-10.8c0-5.1,0-8.9.4-11.7.4-2.8,1.1-4.6,2.5-6,1.3-1.3,3.1-2.1,6-2.5,2.9-.4,5.8-.4,7.7-.4,2.2,0,6.2,0,8.1.5v5.3c0,5.8,0,8.7,2,10.7,2,2,4.9,2,10.7,2h7.6c.7,1.8.8,3.9.8,8.6v4.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M33,30.3c0-2.6-2.4-4.6-5-4-1.5.3-2.7,1.5-3,3-.5,2.1.6,3.9,2.3,4.7.4.2.6.5.6.9v16.1c0,.6.4,1,1,1h0c.6,0,1-.5,1-1v-16.1c0-.4.3-.8.6-.9,1.4-.6,2.4-2.1,2.4-3.7ZM28.9,32.3c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M20.8,38.5h-.7c-.4,0-.8-.2-.9-.6-.8-1.7-2.6-2.8-4.7-2.3s-2.6,1.5-3,3c-.6,2.7,1.4,5,4,5s3.1-1,3.7-2.5.5-.6.9-.6h.7c1.3,0,2.3,1.1,2.3,2.3v8.1c0,.6.5,1,1,1s1-.5,1-1v-8.1c0-2.4-2-4.4-4.4-4.4ZM15.5,41.6c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M43.3,35.6c-2.1-.5-3.9.6-4.7,2.3-.2.4-.5.6-.9.6h-.7c-2.4,0-4.4,2-4.4,4.4v8.1c0,.6.5,1,1,1s1-.5,1-1v-8.1c0-1.3,1.1-2.3,2.3-2.3h.7c.4,0,.8.2.9.6.6,1.4,2.1,2.5,3.7,2.5,2.6,0,4.6-2.4,4-5s-1.5-2.6-3-3ZM42.4,41.6c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z"
		})
	]
});
export default SvgFilegrantIconLogo;
